<template>
  <div class="flex flex-col py-2 px-2">
    <strong class="pb-4">基本信息</strong>
    <div class="finance-wallet-info mb-4">
      <div class="wallet-info-item">
        <label>开户名称</label>
        <span>{{ isNull(data?.airbillAgentLianInfo?.name) ? '--' : data?.airbillAgentLianInfo?.name }}</span>
      </div>
      <div v-if="!isNull(data?.airbillAgentLianInfo?.lianNo)" class="wallet-info-item">
        <label>账户编号</label>
        <span>{{ data?.airbillAgentLianInfo?.lianNo }}</span>
      </div>
      <div v-if="!isNull(data?.airbillAgentLianInfo?.rateNum)" class="wallet-info-item">
        <label>通道费率：</label>
        <span>{{ data?.airbillAgentLianInfo?.rateNum }}%</span>
      </div>
      <div class="wallet-info-item">
        <label>通道状态</label>
        <span>
          <el-tag type="success"> 已启用 </el-tag>
        </span>
      </div>
      <div class="wallet-info-item">
        <label>账户状态</label>
        <span>
          <el-tag type="success"> 已启用 </el-tag>
        </span>
      </div>
    </div>

    <strong class="pb-4">资产信息</strong>
    <!-- 待结算金额 -->
    <div class="finance-wallet-gray">
      <div class="flex flex-col">
        <label>
          <span>可用余额(元)</span>
          <span v-if="!isNull(data?.airbillAgentLianInfo?.withdrawalFreeze)" class="orange">提现中：{{ data?.airbillAgentLianInfo?.withdrawalFreeze }}</span>
        </label>
        <span>{{ !isNull(data?.airbillAgentLianInfo?.withDrawable) ? data?.airbillAgentLianInfo?.withDrawable : '--' }}</span>
      </div>

      <div class="flex justify-end">
        <el-button v-permission="['air:product:account:withdraw']" type="primary" size="small" @click="doWithdraw">
          提现
        </el-button>
        <el-button type="default" size="small" @click="toManage">
          提现记录
        </el-button>
      </div>
    </div>
  </div>
</template>
<script setup lang='ts'>
import { isNull } from '@core/tools';
import { IFinanceWallet } from '@core/main/types';
import { inject, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

const router = useRouter();

let lock = false;

const data = inject<Ref<IFinanceWallet>>('data');

function toManage() {
  router.push({
    name: 'LianlianManage',
    query: {
      from: 'lianlian',
      lianId: data.value?.airbillAgentLianInfo?.lianId,
    },
  });
}

async function doWithdraw() {
  if (lock) return;
  lock = true;

  try {
    router.push({
      name: 'LianliantoWithdrawal',
      query: { lianId: data.value?.airbillAgentLianInfo?.lianId },
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  setTimeout(() => {
    lock = false;
  }, 500);
}
</script>

<style lang="scss" scoped>
.finance-wallet-info {
  @apply flex flex-col bg-[#F7F9FF] text-[#262626] p-[12px] text-[14px];

  &>div {
    @apply flex flex-row justify-between items-baseline pb-2;
  }

  label {
    @apply text-[var(--color-text-desc)] basis-[150px];
  }

  span {
    @apply text-right
  }
}

.finance-wallet-gray {
  @apply flex bg-[#F7F9FF] text-[#262626] p-[12px] text-[12px] justify-between items-center mb-2;

  & > div > span {
    font-size: 18px;
    font-weight: bold;
    padding-top: 3px;
  }

  .orange {
    padding-left: 12px;
    font-size: 10px;
    color: orange;
  }
}
</style>